import React, { useMemo } from 'react';
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';
import { useMediaQuery, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import SpotlightTour from './SpotlightTour';

export const PROBLEMS_TOUR_KEY = 'ch_problems_tour_v1';
export const PROBLEMS_TOUR_START_EVENT = 'ch-start-problems-tour';
export const PROBLEMS_TOUR_COMPLETE_EVENT = 'ch-problems-tour-complete';

const allSteps = [
  {
    id: 'welcome',
    placement: 'center',
    eyebrow: 'Problem set',
    title: 'Find your next problem fast',
    body: 'Filter by topic and difficulty, search by title, or hit Random — then open any row to start coding.',
    cta: 'Show me around',
  },
  {
    id: 'filters',
    target: '[data-tour="filters"]',
    placement: 'right',
    eyebrow: 'Narrow it down',
    title: 'Topics, difficulty & status',
    body: 'Use the sidebar to filter by tags, Easy/Medium/Hard, and solved vs unsolved so the list matches what you want to practice.',
  },
  {
    id: 'search',
    target: '[data-tour="problem-search"]',
    placement: 'bottom',
    eyebrow: 'Find or surprise',
    title: 'Search — or go Random',
    body: 'Type a title to jump to a problem. Feeling stuck? Random picks an unsolved problem that still matches your filters.',
  },
  {
    id: 'list',
    target: '[data-tour="problem-list"]',
    placement: 'left',
    eyebrow: 'Browse & open',
    title: 'Click any row to solve',
    body: 'Only the list scrolls — filters stay put. Open a problem to use the editor, run tests, and submit.',
  },
  {
    id: 'finish',
    placement: 'center',
    eyebrow: 'You’re set',
    title: 'Pick one and ship a solve',
    body: 'Replay this tour anytime with Tour on this page. Happy practicing!',
    cta: 'Start solving',
  },
];

const ProblemsPageTour = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const active =
    location.pathname === '/problems' || location.pathname === '/problems/';

  const steps = useMemo(() => {
    if (isMobile) {
      return allSteps.filter((s) => s.id !== 'list' && s.id !== 'filters');
    }
    return allSteps;
  }, [isMobile]);

  return (
    <SpotlightTour
      steps={steps}
      storageKey={PROBLEMS_TOUR_KEY}
      startEvent={PROBLEMS_TOUR_START_EVENT}
      completeEvent={PROBLEMS_TOUR_COMPLETE_EVENT}
      active={active}
      autoStartDelay={1000}
      isReady={() => Boolean(document.querySelector('[data-tour="problem-search"]'))}
      finishIcon={<CodeOutlinedIcon sx={{ fontSize: 14 }} />}
    />
  );
};

export default ProblemsPageTour;
